<tui-segmented *transloco="let t" class="*:aspect-square *:rounded-full! *:px-0!" [(activeItemIndex)]="previewMode">
  <button type="button" [title]="t('Liste')" (click)="onModeChange(SequencePreviewMode.ROW)">
    <tui-icon icon="@tui.list" />
  </button>
  <button type="button" [title]="t('Grille')" (click)="onModeChange(SequencePreviewMode.TILE)">
    <tui-icon icon="@tui.layout-grid" />
  </button>
</tui-segmented>
